import { render, staticRenderFns } from "./afterSaleList.vue?vue&type=template&id=e0203400&scoped=true&"
import script from "./afterSaleList.vue?vue&type=script&lang=js&"
export * from "./afterSaleList.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleList.vue?vue&type=style&index=0&id=e0203400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0203400",
  null
  
)

export default component.exports